import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Tooltip, OverlayTrigger } from "react-bootstrap";

class Warning extends React.Component {
    renderFlags() {
        if (this.props.value) {
            var tooltip = (<Tooltip id="tooltip">
                <Row>
                    <Col md={12}>
                        There is already a DD214 file uploaded to a different Veteran Owner with the same SSN number.
                        <br />Please review the Veteran information and correct the form data if necessary.
                    </Col>
                </Row>
            </Tooltip>);

            return (
                <React.Fragment key={"flag"}>
                    <OverlayTrigger placement="right" overlay={tooltip}>
                        <FontAwesomeIcon id={"icon"} icon={faExclamationTriangle} size='lg' color="orange" style={{ marginTop: "0px" }} />
                    </OverlayTrigger>
                    <br />
                </React.Fragment>
			)
        }
        else {
            return null;
        }
    }

    render() {
        return (<React.Fragment>
            {this.renderFlags()}
        </React.Fragment>);
    }
}

export default Warning;



// WEBPACK FOOTER //
// ./src/fw/components/formatter/Warning.js